export default __webpack_public_path__ + "static/media/outro-cats_big.d8ef6674.png";